import { render, staticRenderFns } from "./Ingredient_internal.vue?vue&type=template&id=e9a2ef36&scoped=true&"
import script from "./Ingredient_internal.vue?vue&type=script&lang=js&"
export * from "./Ingredient_internal.vue?vue&type=script&lang=js&"
import style0 from "./Ingredient_internal.vue?vue&type=style&index=0&id=e9a2ef36&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9a2ef36",
  null
  
)

export default component.exports